export const transformSlots = (slots?: number[]): string => {
  if (!slots || !slots.length) {
    return "";
  }
  return transformSlotsPartial(slots).join(", ");
};

export const transformSlotsPartial = (slots: number[]): string[] => {
  const sortedSlots = slots.toSorted((a: number, b: number) => a - b);
  const result: number[][] = [[]];

  for (const slot of sortedSlots) {
    const lastChunk = result[result.length - 1] as number[];

    if (!lastChunk.length) {
      lastChunk.push(slot); // первый чанк заполняем первым слотом
      continue;
    }

    if ((lastChunk[lastChunk.length - 1] as number) - slot === -1) {
      // если следующий слот соседний
      lastChunk.push(slot); // добавляем его в этот чанк
      continue;
    }

    if ((lastChunk[lastChunk.length - 1] as number) - slot < -1) {
      // если следующий слот не соседний
      result.push([slot]); // создаём новый чанк
    }
  }

  return result.map((chunk) =>
    `${chunk[0]}:00–${+(chunk[chunk.length - 1] as number) + 1}:00`.replace("24:00", "00:00"),
  );
};
